const MAX_RETRIES = 60;
const CHECK_INTERVAL = 100; // in ms

let retryCount = 0;
let lastPosition = 0;
let userScrolled = false;
let scriptScrolling = false;
let hashElementCache = null;

const scrollEvent = () => {
  if (!scriptScrolling) {
    // User scrolled: Cancelling auto-scroll logic
    userScrolled = true;
    unbindScrollEvents();
  }
};

const bindScrollEvents = () => {
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", scrollEvent, { passive: true });
    window.addEventListener("wheel", scrollEvent, { passive: true });
    window.addEventListener("touchmove", scrollEvent, { passive: true });
  }
};

const unbindScrollEvents = () => {
  if (typeof window !== "undefined") {
    window.removeEventListener("scroll", scrollEvent);
    window.removeEventListener("wheel", scrollEvent);
    window.removeEventListener("touchmove", scrollEvent);
  }
};

const performScroll = (element) => {
  scriptScrolling = true;
  unbindScrollEvents();
  element.scrollIntoView({ behavior: "instant" }); // Was set to smooth but required a longer timeout and didn't look good
  setTimeout(() => {
    scriptScrolling = false;
    bindScrollEvents();
  }, 200);
};

const getHashElement = () => {
  if (hashElementCache) {
    return hashElementCache;
  }
  hashElementCache = document.getElementById(
    window.location.hash.replace(/^#/, "")
  );
  return hashElementCache;
};

const resetScrollState = () => {
  retryCount = 0;
  lastPosition = 0;
  userScrolled = false;
  scriptScrolling = false;
  hashElementCache = null;

  // Initially bind scroll events to capture user scrolls.
  unbindScrollEvents();
  bindScrollEvents();
};

const scrollToHashElementDuringLayoutChanges = () => {
  if (userScrolled) {
    return;
  }

  const element = getHashElement();

  if (!element) {
    // If the element isn’t in the DOM yet
    if (retryCount < MAX_RETRIES) {
      retryCount++;
      setTimeout(scrollToHashElementDuringLayoutChanges, CHECK_INTERVAL);
    }
  } else {
    // Element is found—get Calculate the absolute Y-position of the element on the page.
    const currentPosition =
      element.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop);

    if (
      Math.abs(currentPosition - lastPosition) > 50 &&
      retryCount < MAX_RETRIES
    ) {
      lastPosition = currentPosition;

      // If the element moved more than 50px since last check, track position and keep checking.
      performScroll(element);

      // Keep checking in case the layout shifts further.
      retryCount++;
      setTimeout(scrollToHashElementDuringLayoutChanges, CHECK_INTERVAL);
    } else {
      // The element's position appears stable, so scroll it into view.
      performScroll(element);

      if (retryCount < MAX_RETRIES) {
        // Keep checking in case the layout shifts further.
        retryCount++;
        setTimeout(scrollToHashElementDuringLayoutChanges, CHECK_INTERVAL);
      }
    }
  }
};

export const scrollToHashElement = () => {
  window.setTimeout(() => {
    requestAnimationFrame(() => {
      resetScrollState();
      scrollToHashElementDuringLayoutChanges();
    });
  }, 200); // Add extra delay to make it work on iOS
};

export const scrollToTop = () => {
  // Scroll to top of page (see https://github.com/preactjs/preact-router/issues/319)
  window.scrollTo({ top: 0 });
};
